import { t } from 'i18next';

import {
  AccessBlockAction,
  AccessBlockScheduleType,
  AccessBlockType,
} from '../../../../types/apiResponse/accessBlock';

export const accessBlockTypeOptions = () => [
  { value: 'block' as AccessBlockType, label: t('block') as string },
  { value: 'allow' as AccessBlockType, label: t('release') as string },
];

export const accessBlockScheduleOptions = () => [
  { value: 'weekday' as AccessBlockScheduleType, label: t('weekDay') as string },
  { value: 'specific_date' as AccessBlockScheduleType, label: t('specificDate') as string },
  { value: 'period' as AccessBlockScheduleType, label: t('period') as string },
];

export const accessBlockActionOptions = () => [
  {
    value: 'login' as AccessBlockAction,
    label: t('login') as string,
    description: t('loginActionHint') as string,
  },
  {
    value: 'order' as AccessBlockAction,
    label: t('makeOrder') as string,
    description: t('orderActionHint') as string,
  },
];

export const weekdays = () => [
  { value: 1, label: t('monday') as string },
  { value: 2, label: t('tuesday') as string },
  { value: 3, label: t('wednesday') as string },
  { value: 4, label: t('thursday') as string },
  { value: 5, label: t('friday') as string },
  { value: 6, label: t('saturday') as string },
  { value: 7, label: t('sunday') as string },
];

export const timeOptions = () => {
  const options: { value: string; label: string }[] = [];

  for (let hour = 0; hour < 24; hour += 1) {
    for (let minute = 0; minute < 60; minute += 15) {
      const value = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
      options.push({ value, label: value });
    }
  }

  return options;
};
